export default {
      id: "oc-cpu-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-cpu",
      toString: function () {
        return this.url;
      }
    }